import { PayUInput, PayUForm, PayURef } from '@shared/components/payu';
import { getCountryNames, Masks } from '@helpers/constant';
import { FormSelect, FormInput } from '@ui/components';
import { useTranslation } from 'react-i18next';
import { Control } from 'react-hook-form';
import { useMemo, FC } from 'react';

import { TopUpFormSchema } from '../../../hooks';

export interface CreditCardFormProps {
  formControl: Control<TopUpFormSchema>;
  disabled?: boolean;
  payURef: PayURef;
  payUID: string;
}

export const CreditCardForm: FC<CreditCardFormProps> = ({
  disabled = false,
  formControl,
  payURef,
  payUID,
}) => {
  const { t, i18n } = useTranslation();

  const countries = useMemo(
    () => getCountryNames(i18n.language as 'pl' | 'ru' | 'uk' | 'en'),
    [i18n.language],
  );

  return (
    <div className="grid grid-cols-2 gap-6">
      <FormInput
        componentProps={{
          hasShadow: true,
        }}
        placeholder={t('ONBOARDING.TOP_UP.FIRST_NAME')}
        formControl={formControl}
        disabled={disabled}
        name="firstName"
        size="large"
        required
        floating
      />
      <FormInput
        componentProps={{
          hasShadow: true,
        }}
        placeholder={t('ONBOARDING.TOP_UP.LAST_NAME')}
        formControl={formControl}
        disabled={disabled}
        name="lastName"
        size="large"
        required
        floating
      />

      <PayUForm payUID={payUID} ref={payURef}>
        <PayUInput
          placeholder={t('ONBOARDING.TOP_UP.CARD_NUMBER')}
          payUControlType="number"
          className="col-span-2"
          id="payu-card-number"
          disabled={disabled}
          name="cardNumber"
          inputSize="large"
          hasShadow
          floating
          required
        />
        <PayUInput
          placeholder={t('ONBOARDING.TOP_UP.CARD_DATE')}
          payUControlType="date"
          disabled={disabled}
          id="payu-card-date"
          inputSize="large"
          name="cardDate"
          hasShadow
          floating
          required
        />
        <PayUInput
          placeholder={t('ONBOARDING.TOP_UP.CARD_CVV')}
          payUControlType="cvv"
          disabled={disabled}
          id="payu-card-cvv"
          inputSize="large"
          name="cardCvv"
          hasShadow
          floating
          required
        />
      </PayUForm>

      <FormSelect
        componentProps={{
          hasShadow: true,
        }}
        placeholder={t('ONBOARDING.TOP_UP.COUNTRY')}
        formControl={formControl}
        className="col-span-2"
        options={countries}
        disabled={disabled}
        name="country"
        size="large"
        required
        floating
      />
      <FormInput
        componentProps={{
          hasShadow: true,
          maskOptions: {
            mask: Masks.ZIP_CODE,
          },
        }}
        placeholder={t('ONBOARDING.TOP_UP.ZIP_CODE')}
        formControl={formControl}
        className="col-span-2"
        disabled={disabled}
        name="zipCode"
        size="large"
        required
        floating
      />
    </div>
  );
};
